import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useGetAddressesQuery, useGetAddressGroupCountQuery } from "../../../../store/api/address";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import PopBox from "../../../../Components/Popup/Popup";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ExportCSV from '../../../../Core/Export/ExportCSV'
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import useScreenHeight from "../../../../utils/useScreenHeight";
const MainContent = () => {
    const navigate = useNavigate();
    const { screenHeight, screenScaling ,pageSize } = useScreenHeight();
    const [filters, setFilters] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [isPopBoxOpen, setIsPopBoxOpen] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [addressData, setAddressData] = useState([]);
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [showFilters, setShowFilters] = useState(false)
    const [showColumnConfig, setShowColumnConfig] = useState(false)
    const siNoFilter = filters.siNo?.trim();
    const isSiNoActive = siNoFilter !== undefined && siNoFilter !== "";
    const targetPage = isSiNoActive
        ? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
        : currentPage;
    const doctype = "Address";
	const [deleteDoc] = useDeleteDocMutation();
	const [delPopupVisible, setDelPopupVisible] = useState(false);
	const [delSelectedId, setDelSelectedId] = useState(null);
	const [delmessage, setDelmessage] = useState();
	const [alreadySubmitData, setAlreadySubmitData] = useState(false);
    const [delDone, setDelDone] = useState(false);
    
    const buildFilterArray = (filtersObj) => {
        return Object.entries(filtersObj)
            .filter(([key, value]) => key !== "siNo" && value?.trim() !== "")
            .map(([key, value]) => {
                if (key === "creation") {
                    return ["Address", key, "like", `${value}%`];
                }
                if (key === "name") {
                    return ["Address", key, "like", `%${value}%`];
                }
                if (key === "address_type") {
                    return ["Address", key, "like", `%${value}%`];
                }
                if (key === "city") {
                    return ["Address", key, "like", `%${value}%`];
                }
                return ["Address", key, "=", value];
            });
    };

    const { data, isLoading, refetch:refetchAddressData } = useGetAddressesQuery({
        start: (targetPage - 1) * pageSize,
        limit: pageSize,
        filters: buildFilterArray(filters),
    });

    const { data: totalCount , refetch:reftechAddressCount} = useGetAddressGroupCountQuery();

    useEffect(() => {
        if (totalCount) {
            setTotalRecords(totalCount?.message);
        }
    }, [totalCount]);

    useEffect(() => {
        if (data?.data) {
            const rawData = data?.data || [];
            const numberedData = rawData.map((item, idx) => ({
                ...item,
                siNo: idx + 1 + pageSize * (targetPage - 1),
            }));
            const finalData = isSiNoActive
                ? numberedData.filter(item => item.siNo === parseInt(siNoFilter, 10))
                : numberedData;

            setAddressData(finalData);
            if (isSiNoActive && currentPage !== targetPage) {
                setCurrentPage(targetPage);
            }
        }
    }, [data, isSiNoActive, siNoFilter, targetPage, currentPage, pageSize]);

    useEffect(() => {
        
            if(pageSize > 0)
			    refetchAddressData();
		}, [filters, currentPage, refetchAddressData,pageSize,screenScaling,screenHeight]);

    const filtersConfig = [
        { name: 'siNo', label: 'SI.No', width: '7%', type: 'number' },
        { name: 'name', label: 'Id', width: '23%', type: 'text' },
        { name: 'address_type', label: 'Address Type', width: '19%', type: 'text' },
        { name: 'city', label: 'City/Town', width: '20%', type: 'text' },
        {
            name: "disabled",
            label: "Status",
            width: "17%",
            type: "select",
            options: [
                { value: "0", label: "Enabled" },
                { value: "1", label: "Disabled" },
            ],
        },
    ];

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        setCurrentPage(1);
    };

    const handleView = (addressName) => {
        navigate(`/master/address/view-address/`, { state: { addressName } });
    };

    const handleEdit = (addressName) => {
        navigate(`/master/address/edit-address/`, { state: { addressName } });
    };

const handleDelete = (id) => {
	setDelSelectedId(id);
	setDelPopupVisible(true);
	setAlreadySubmitData(false);
	setDelmessage(`Are you sure you want to Delete this ${doctype}?`);
};

const delHandleCancel = () => {
	setDelPopupVisible(false);
	setDelSelectedId(null);
};

const delHandleConfirm = async () => {
	try {
		await deleteDoc({
			doctype: doctype,
			name: delSelectedId,
		}).unwrap();
		setDelmessage(`${doctype} ${delSelectedId} deleted successfully!`);
		setDelDone(true);
		setTimeout(() => {
			setDelPopupVisible(false);
			setDelSelectedId(null);
			setDelDone(false);
			refetchAddressData();
			reftechAddressCount();
		}, 1000);
	} catch (err) {
		console.error("Deletion Failed:", err);

		let errorMessage = `Failed to delete the ${doctype}!`;

		//If the server is sending the error message , we will extract it.
		if (err?.data?._server_messages) {
			try {
				const messageArr = JSON.parse(err.data._server_messages);
				if (messageArr && messageArr.length > 0) {
					//parse inner json object
					const messageObj = JSON.parse(messageArr[0]);
					if (messageObj?.message) {
						//extract the exact message we want
						const fullMessage = messageObj.message;
						errorMessage = fullMessage.split("You must")[0].trim();
						//remove html in the message
						errorMessage = errorMessage.replace(/<[^>]+>/g, "");
					}
				}
			} catch (parseError) {
				console.error("Error parsing server messages:", parseError);
			}
		}
		setDelPopupVisible(true);
		setDelmessage(errorMessage);
		setAlreadySubmitData(true);
	} finally {
		// setTimeout(() => {
		//     setDelPopupVisible(false);
		//     setDelSelectedId(null);
		// }, 2000);
	}
};

    const [columnsConfig, setColumnsConfig] = useState(() => [
        {
            header: "SI No.",
            accessor: "siNo",
            name: "SI No.",
            visible: true,
            sortable: false,
        },
        {
            header: "Id", accessor: "name", sortable: false,
            name: "Id",
            visible: true,
        },
        {
            header: "Address Type", accessor: "address_type", sortable: false,
            name: "Address Type",
            visible: true,
        },
        {
            header: "City/Town", accessor: "city", sortable: true,
            name: "City/Town",
            visible: true,
        },
        {
            header: "Date",
            accessor: "creation",
            sortable: true,
            name: "Date",
            visible: true,
            cellRenderer: (row) => row.creation?.split(" ")[0],
        },
        {
            header: "Status",
            accessor: "disabled",
            sortable: true,
            name: "Status",
            visible: true,
            cellRenderer: (row) => {
                const isDisabled = row.disabled;
                const statusText = isDisabled === 0 ? "Enabled" : "Disabled";
                const color = isDisabled === 0 ? "#16A34A" : "#EF4444";
                return <span style={{ color }}>{statusText}</span>;
            }
        },
        {
            header: "Action",
            accessor: "action",
            name: "Action",
            visible: true,
            cellRenderer: (row) => (
                <ActionButtonDropdown
                    id={row.name}
                    onView={() => handleView(row.name)}
                    onEdit={() => handleEdit(row.name)}
                    onDelete={() => handleDelete(row.name)}
                />
            ),
        },
    ]);
    // Handle column configuration changes
    const handleSaveColumns = (selectedKeys, allFields) => {
        const updatedColumns = columnsConfig.map(column => {
            return {
                ...column,
                visible: selectedKeys.includes(column.accessor)
            };
        });
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible === true),
        [columnsConfig]
    );

    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible === true)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            }))
            .filter(col => col.fieldname),
        [columnsConfig]
    );
    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);

    const actionButtons = [
        {
            className: "createbtnsfilter border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "createbtnshowmore border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "createbtnexport border-0 d-flex",
            style: { gap: '2px', height: '28px' ,backgroundColor : '#E6A744'},
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),
        },
        {
            className: "custom-btn-00989 d-flex",
            to: "/master/address/create-address",
            iconName: "FiPlus",
            style: { gap: '2px', height: '28px' },
            children: "Add Address"
        }
    ];

    const accessors = columnsConfig
        .filter(column => column.accessor !== "siNo" && column.accessor !=="action")
        .map(column => column.accessor);
    
    // console.log("accessors",accessors)

    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Address" },
                    { label: "Address List", style: { color: '#4b002b' } }
                ]}
                actionButtons={actionButtons}
            >
                {
                    showFilters && <ListFilters
                        filtersConfig={filtersConfig}
                        onFilterChange={handleFilterChange}
                        currentFilters={filters}
                        setShowFilters={setShowFilters}
                    />
                }

                {showColumnConfig &&
                    <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="Address"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo", "action", "address_type", "name", "disabled"]}
                    />}

                <Table
                    columns={visibleColumns}
                    data={addressData}
                    loading={isLoading}
                />
                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={totalRecords}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
				{delPopupVisible && (
					<DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
                )}
                {showExportPopup && (
                    <ExportCSV
                        doctype="Address"
                        fieldsData= {accessors}
                        onClose={() => setShowExportPopup(false)}
                    />
                )}
                <PopBox
                    isOpen={isPopBoxOpen}
                    onClose={() => setIsPopBoxOpen(false)}
                    title="Select Company"
                >
                    <div className="selectbox">
                        <p>Settings content goes here</p>
                    </div>
                </PopBox>
            </ListLayout>
        </div>
    );
};

export default MainContent;
